import React from 'react';
import {Form, FormGroup} from 'react-bootstrap';
import { Radio } from 'react-icheck';
import {connect} from 'react-redux'

class RadioDeliveringAs extends React.Component {

  constructor(...args) {
    super(...args);

    this.state = {}
  }

  onFormChange(type) {
    this.props.onChange(type)
    if (this.props.onDeliveringAsChange!==undefined)
        this.props.onDeliveringAsChange(type)
  }

  render() {
    const {
      formData,
      uiSchema
    } = this.props;
    let type = 'customer'
    if (typeof uiSchema.type!=='undefined') {
        if (uiSchema.type==='driver') {
            type = 'driver'
        }
    }
    return (
        <Form inline>
            <FormGroup>
                <Radio
                    checked={formData===type?true:false}
                    onChange={this.onFormChange.bind(this,type)}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label=" ใช้ชื่อลูกค้า"
                >
                </Radio>
            </FormGroup>
            {' '}
            <FormGroup>
                <Radio
                    checked={formData==='other'?true:false}
                    onChange={this.onFormChange.bind(this,'other')}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label=" อื่นๆ"
                >
                </Radio>
            </FormGroup>
        </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const _Connect = connect(
    mapStateToProps,
)(RadioDeliveringAs);

export default _Connect;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/RadioDeliveringAs.js